<template>
	<div>
		<v-layout wrap py-3 px-3>
			<v-flex xs12>
				<span class="caption">Asiento</span>
				<BaseInput
					disabled
					:height="33"
					hide-details
					v-model="model.code"
				/>
			</v-flex>
			<v-flex xs12 px-2 mb-3>
				<span class="caption">Fecha</span>
				<BaseDate
					disabled
					:height="33"
					id="seat-date"
					v-model="model.date"
				/>
				<span class="caption error--text"
					v-if="$v.model.date.$invalid">
					La fecha es requerida.
				</span>
			</v-flex>
			<v-flex xs12 px-2>
				<span class="caption">Descripción</span>
				<v-textarea
					v-model="model.gloss"
					hide-details
					background-color="white"
					no-resize
					solo
					class="base-textarea"
				/>
			</v-flex>
			<v-flex xs12 px-2 mb-3>
				<span class="caption">Origen</span>
				<BaseSelect
					disabled
					return-object
					:height="33"
					:placeholder="model.moduleCode"
					item-text="name"
					item-value="id"
					:items="modules"
					:value="moduleValue"
					@input="$emit('set-module-data', $event)"
				/>
			</v-flex>
			<v-flex xs12 px-2 v-if="!isEcuador">
				<span class="caption">Moneda</span>
				<BaseSelect
					disabled
					:height="33"
					item-text="code"
					item-value="code"
					:items="currencies"
					v-model="model.currency"
				/>
			</v-flex>
		</v-layout>
		<section class="modal-filter-footer">
			<modal-sidebar-button
				:is-loading="disabledBtn"
				@cancel-button-clicked="$emit('close-modal')"
				@accept-button-clicked="$emit('save', model)"
			>
			</modal-sidebar-button>
		</section>
	</div>
</template>

<script>
	import { mapGetters } from 'vuex';
	import { required } from 'vuelidate/lib/validators';
	import countries from '@/shared/countries';

	function disabledBtn() {
		return this.loading || this.$v.$invalid;
	}

	function onDate(value) {
		this.model.date = value;
	}

	function isEcuador() {
		return this.customer ?
			this.customer.company.countryId === countries.Ecuador : false;
	}

	function validations() {
		return {
			model: {
				date: { required },
			},
		};
	}

	function data() {
		return {
			currencies: [
				{ id: 1, name: 'Soles', code: 'PEN' },
				{ id: 2, name: 'Dólares', code: 'USD' },
			],
			disabled: false,
			subsidiary: {},
			subsidiaries: [],
			valueDate: null,
		};
	}

	export default {
		name: 'journal-seat-form',
		components: {
			BaseDate: () => import('@/components/shared/inputs/base-date'),
			BaseInput: () => import('@/components/shared/inputs/base-input'),
			BaseSelect: () => import('@/components/shared/inputs/base-select'),
		},
		computed: {
			...mapGetters('currentSubsidiary', [
				'currentSubsidiary',
			]),
			disabledBtn,
			isEcuador,
		},
		data,
		methods: {
			onDate,
		},
		props: {
			loading: {
				default: false,
				type: Boolean,
			},
			model: {
				type: Object,
				default: () => {},
			},
			modules: {
				default: () => [],
				type: Array,
			},
			moduleValue: {
				default: () => {},
				type: Object,
			},
			customerId: [String, Number],
			subsidiaryId: [String, Number],
			customer: {
				type: Object,
				default: () => {},
			},
		},
		validations,
	};
</script>



// WEBPACK FOOTER //
// src/components/journal/journal-seat-form.vue